import TextField from './TextField';
import type { ClientDealForm as Form } from './use-client-deal-form';

/** The deposit checkbox, which reveals the HubSpot payment id once ticked. */
export default function ClientDealDepositFields({ form }: { form: Form }) {
  const { draft, set, fieldError } = form;
  return (
    <>
      <label
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          fontSize: 13,
          fontWeight: 600,
          color: 'var(--nb-ink-2)',
        }}
      >
        <input
          type="checkbox"
          checked={draft.depositReceived}
          onChange={(e) => set('depositReceived', e.target.checked)}
          style={{ width: 15, height: 15, accentColor: 'var(--nb-primary)', margin: 0 }}
        />
        Deposit received
      </label>
      {draft.depositReceived && (
        <TextField
          label="HubSpot payment"
          hint="the payment id from the deal’s payment record"
          value={draft.hubspotPaymentId}
          onChange={(v) => set('hubspotPaymentId', v)}
          error={fieldError('hubspotPaymentId')}
          placeholder="e.g. 6315340064"
          maxWidth={220}
        />
      )}
    </>
  );
}
